export default __webpack_public_path__ + "static/media/rental-badge.1f155356.svg";